import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import environment from 'shared/relay/environment';
import configureStore from 'shared/store/configure-store';
import { PATH_PRIVATE_HOME, privateRoutes, publicRoutes } from 'tracker.routes';

const routerSettings = {
  environment
};

const store = configureStore();

export default function App() {
  function renderPrivateRoutes(path) {
    return privateRoutes.map(route => (
      <Route
        key={route.key}
        exact
        path={`${path}/${route.path}`}
        render={props => <route.component {...props} />}
      />
    ));
  }
  return (
    <Provider store={store}>
      <Router {...routerSettings}>
        <Switch>
          <Route
            path={PATH_PRIVATE_HOME}
            render={({ match: { path } }) => (
              <Switch>{renderPrivateRoutes(path)}</Switch>
            )}
          />
          {publicRoutes.map(route => (
            <Route
              key={route.key}
              exact
              path={route.path}
              render={props => <route.component {...props} />}
            />
          ))}
        </Switch>
      </Router>
    </Provider>
  );
}
